import { DashboardWidgetResponse } from '../../../../../../types/api/endpoints/stats/dashboard.types';
import { STATS_ENDPOINTS } from '../../../../../../utils/api/endpoints/statsEndpoints';

export const DASHBOARD_COM_WIDGET_QUERY_KEY = 'DASHBOARD_COM_WIDGET';

const PREFIX = '[dashboardCOMWidgetQuery]';

export const queryDashboardCOMWidget = async () => {
  console.log(PREFIX, `Fetching dashboard COM widget...`);
  const response = await STATS_ENDPOINTS.dashboardCOMWidget();

  const { ok, data: json } = response;

  if (!ok) {
    const error = response.data;
    console.log(PREFIX, 'An error occurred.', error);
    throw error;
  }

  console.log(PREFIX, `Received dashboard COM widget.`);
  return json as DashboardWidgetResponse;
};
